<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ users.id ? $t('user.form.editTitle') : $t('user.form.newTitle') }}
              </div>
            </div>
            <div class="card-body">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label><span class="required">*</span> {{ $t('user.form.nameLabel') }}</label>
                  <input
                    v-model="users.name"
                    type="text"
                    class="form-control"
                    autocomplete="off"
                    placeholder=""
                  />
                </div>
                <div class="form-group col-md-6">
                  <label><span class="required">*</span> {{ $t('user.form.loginLabel') }}</label>
                  <input
                    v-model="users.login"
                    type="text"
                    class="form-control"
                    autocomplete="off"
                    placeholder=""
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label><span class="required">*</span> {{ $t('user.form.accessLevelLabel') }}</label>
                  <select
                    v-model="users.access_nivel"
                    class="form-control"
                  >
                    <option :value="3">{{ $t('user.form.accessLevelStandard') }}</option>
                    <option :value="2">{{ $t('user.form.accessLevelManager') }}</option>
                    <option
                      v-if="$store.state.user.access_nivel == 1"
                      :value="1"
                    >
                      {{ $t('user.form.accessLevelAdmin') }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label>{{ $t('user.form.accessIpLabel') }}</label>
                  <input
                    v-model="users.access_ip"
                    type="text"
                    class="form-control"
                    :placeholder="$t('user.form.accessIpPlaceholder')"
                  />
                  <small class="text-muted">{{ $t('user.form.accessIpHint') }}</small>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>{{ $t('user.form.cpfLabel') }}</label>
                  <input
                    v-model="users.cpf"
                    type="text"
                    class="form-control"
                    v-mask="'999.999.999-99'"
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label>{{ $t('user.form.professionalLabel') }}</label>
                  <v-select
                    v-model="users.professional_id"
                    :options="professionals"
                    :reduce="(p) => p.id"
                    label="display_name"
                    class="vselect"
                    :placeholder="$t('user.form.professionalPlaceholder')"
                  />
                  <small class="text-muted">
                    {{ $t('user.form.professionalHint') }}
                  </small>
                </div>
              </div>

              <!-- Senha: sempre visível em criação; toggle em edição -->
              <div
                v-if="users.id"
                class="mb-2"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  @click="change_password = !change_password"
                >
                  <i class="fas fa-key mr-1" /> {{ change_password ? $t('user.form.hidePassword') : $t('user.form.changePassword') }}
                </button>
              </div>

              <div
                v-if="change_password"
                class="form-row"
              >
                <div class="form-group col-md-6">
                  <label><span class="required">*</span> {{ $t('user.form.passwordLabel') }}</label>
                  <input
                    v-model="users.password"
                    type="password"
                    class="form-control"
                    autocomplete="new-password"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label><span class="required">*</span> {{ $t('user.form.passwordConfirmationLabel') }}</label>
                  <input
                    v-model="users.password_confirmation"
                    type="password"
                    class="form-control"
                    autocomplete="new-password"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>{{ $t('user.form.photoLabel') }}</label>
                <div class="user-img mb-1">
                  <img
                    v-if="previewImage"
                    :src="previewImage"
                    class="photo"
                  />
                </div>
                <input
                  id="userPic"
                  type="file"
                  accept="image/*"
                  @change="uploadImage"
                />
              </div>

              <hr />

              <span class="required_fields">
                <span class="required">*</span>
                <strong>{{ $t('user.form.requiredFields') }}</strong>
              </span>
              <div class="block text-right mt-1">
                <router-link
                  to="/users"
                  class="btn btn-back mr-1"
                >
                  <i class="fa fa-arrow-left" /> {{ $t('common.back') }}
                </router-link>
                <button
                  v-if="$hasAbility('usuario.gerenciar')"
                  type="button"
                  class="btn btn-add"
                  :disabled="saving"
                  @click="save"
                >
                  <span
                    v-if="saving"
                    class="spinner-border spinner-border-sm mr-1"
                  />
                  <i
                    v-else
                    class="fa fa-save"
                  />
                  {{ $t('common.save') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'UserAdd',
  components: { vSelect },
  data() {
    return {
      saving: false,
      professionals: [],
      change_password: true,
      users: {
        id: null,
        name: '',
        login: '',
        access_nivel: 3,
        access_ip: '',
        cpf: '',
        professional_id: null,
        password: '',
        password_confirmation: '',
        photo: '',
      },
      previewImage: null,
    }
  },
  mounted() {
    this.getProfessionals()

    const id = this.$route.params.id
    if (id) {
      this.change_password = false
      this.getUser(id)
    }
  },
  methods: {
    getProfessionals() {
      axios
        .get(this.$store.state.api + 'professionals?paginated=false&with=cbo')
        .then(res => {
          const list = res.data.data || res.data || []
          this.professionals = list.map(p => ({
            id: p.id,
            display_name: p.name + (p.cbo ? ' — ' + p.cbo.code : ''),
          }))
        })
        .catch(() => {})
    },
    getUser(id) {
      this.$loading(true)
      axios
        .get(this.$store.state.api + 'users/' + id)
        .then(res => {
          const user = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data
          if (user) {
            this.users = {
              ...this.users,
              ...user,
              password: '',
              password_confirmation: '',
            }
          }
        })
        .catch(err => {
          const msg = err && err.response && err.response.data
            ? err.response.data
            : this.$t('user.messages.loadError')
          this.$message(this.$t('user.messages.errorTitle'), msg, 'error')
        })
        .finally(() => {
          this.$loading(false)
        })
    },
    uploadImage(e) {
      const file = e.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = ev => { this.previewImage = ev.target.result }
    },
    save() {
      this.saving = true
      const api = this.$store.state.api + 'users' + (this.users.id ? '/' + this.users.id : '')

      const fd = new FormData()
      fd.append('name', this.users.name || '')
      fd.append('login', this.users.login || '')
      fd.append('access_nivel', this.users.access_nivel || '')
      fd.append('access_ip', this.users.access_ip || '')
      fd.append('cpf', this.users.cpf || '')
      fd.append('professional_id', this.users.professional_id || '')
      fd.append('rg', this.users.rg || '')
      fd.append('cellphone', this.users.cellphone || '')
      fd.append('status', this.users.status || '')
      fd.append('login_attempts', 0)

      if (this.change_password) {
        fd.append('password', this.users.password || '')
        fd.append('password_confirmation', this.users.password_confirmation || '')
      }

      const photo = document.getElementById('userPic')
      if (photo && photo.files[0]) {
        fd.append('photo', photo.files[0])
      }

      fd.append('_method', this.users.id ? 'PUT' : 'POST')
      if (this.users.id) fd.append('id', this.users.id)

      axios
        .post(api, fd)
        .then(() => {
          this.$message(this.$t('user.messages.successTitle'), this.$t('user.messages.saveSuccess'), 'success')
          this.$router.push('/users')
        })
        .catch(err => {
          const msg = err && err.response && err.response.data
            ? err.response.data
            : this.$t('user.messages.saveError')
          this.$message(this.$t('user.messages.errorTitle'), msg, 'error')
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>

<style scoped>
.photo {
  display: block;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  object-fit: cover;
}
</style>
